import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseKey);

// Database table types
export interface DatabaseProperty {
  id: string;
  title: string;
  price: number;
  location: string;
  area: number;
  bedrooms: number;
  bathrooms: number;
  garages: number;
  floor: number;
  type: 'sale' | 'rent';
  category: string;
  categoryId: string;
  description: string;
  mainImage: string;
  galleryImages: string[];
  videoUrl?: string;
  adminNote?: string;
  featured: boolean;
  facilities: string[];
  nearby: string[];
  coordinates?: { lat: number; lng: number };
  created_at: string;
}

export interface DatabaseCategory {
  id: string;
  name: string;
  name_en: string;
  icon: string;
  created_at: string;
}
